import { createSlice } from '@reduxjs/toolkit';
import {
  getStoreSyncConfigReducers,
  updateStoreSyncConfigReducers,
  synchronizeStoresReducers,
  storeSyncProgressReducers,
} from './store-synchronization.reducers';

const initialState = {
  syncConfig: null,
  lastSyncResult: null,
  syncProcessStatus: null,
  isSyncRunning: false,

  getStoreSyncConfigStatus: 'idle',
  updateStoreSyncConfigStatus: 'idle',
  synchronizeStoresStatus: 'idle',
  downloadSyncReportStatus: 'idle',

  error: null,
};

const storeSynchronizationSlice = createSlice({
  name: 'storeSynchronization',
  initialState,
  reducers: {
    clearSyncError: (state) => {
      state.error = null;
    },
    resetSyncStatuses: (state) => {
      state.getStoreSyncConfigStatus = 'idle';
      state.updateStoreSyncConfigStatus = 'idle';
      state.synchronizeStoresStatus = 'idle';
    },
    setSyncProcessStatusFromSocket(state, action) {
      state.syncProcessStatus = action.payload;
      state.isSyncRunning = Boolean(action.payload?.isRunning);
    },
  },
  extraReducers: (builder) => {
    getStoreSyncConfigReducers(builder);
    updateStoreSyncConfigReducers(builder);
    synchronizeStoresReducers(builder);
    storeSyncProgressReducers(builder);
  },
});

export const { clearSyncError, resetSyncStatuses, setSyncProcessStatusFromSocket } =
  storeSynchronizationSlice.actions;
export default storeSynchronizationSlice.reducer;
